<template>
    <b-modal
        id="portfolio-assignment-tag-select"
        v-model="modal"
        modal-class="apprentice-default-modal"
        :title="$t('portfolio.select_tag')"
        size="md"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        :ok-title="$t('common.save')"
        @ok="storeSelectedTag"
        @onshow="show">
        <div class="selected-tags-overview">
            <div class="current-selected-tag"></div>
            <div class="available-tags">
                <design-2021-apprentice-multiselect-component
                    class="available-tags"
                    v-model="selectedTags"
                    :placeholder="$t('portfolio.choose_tag')"
                    label="name"
                    track-by="id"
                    :allow-empty="true"
                    :multiple-select="true"
                    :options="tags"
                    :show-labels="false"
                    :deselectLabel="$t('portfolio.click_again_to_delete')">
                    <template #singleLabel="props">
                        <div class="tag-icon">
                            <i
                                class="fas fa-fw fa-circle"
                                v-if="props.option.id !== null"
                                :style="{ color: props.option.color }"></i>
                            {{ props.option.name }}
                        </div>
                    </template>

                    <template #option="props">
                        <div class="tag-option">
                            <i
                                class="fas fa-fw fa-circle"
                                v-if="props.option.id !== null"
                                :style="{ color: props.option.color }"></i
                            >{{ props.option.name }}
                        </div>
                    </template>
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-assignment-tag-select-modal-component',
    props: {
        groupId: {
            type: Number,
            required: true,
        },
        availableTags: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            modal: false,
            selectedTags: [],
            assignmentId: null,
            tags: [],
        };
    },

    methods: {
        storeSelectedTag(bvModalEvent) {
            const data = new FormData();

            if (this.selectedTags.length) {
                let needle = 0;
                for (const tag of this.selectedTags) {
                    data.append(`tag[${needle}][tag_id]`, tag.id);
                    data.append(`tag[${needle}][tag_name]`, tag.name);
                    data.append(`tag[${needle}][tag_color]`, tag.color);
                    needle++;
                }
            }

            this.alert.saving();
            this.axios.post(this.routes.storeAssignmentTag(this.assignmentId), data).then(
                (response) => {
                    this.$emit('stored-tag', response.data, this.assignmentId);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        show(assignment) {
            this.assignmentId = assignment.id;
            this.selectedTags = assignment.assignment_tags.length > 0 ? assignment.assignment_tags : [];
            this.tags = [...this.availableTags];
            this.tags.unshift({
                id: null,
                name: this.$t('portfolio.no_tag'),
            });
            this.modal = true;
        },
    },
};
</script>

<style scoped></style>
